import React, {useContext, useState} from 'react';
import {GlobalInfo} from "./context";
import {numberWithCommas, shortNumber} from "./util";
import {EngineerOnly, TransactButton, Toggle} from "./Common";
import {useTranslation} from "react-i18next";

function ISK(props) {
  return numberWithCommas(props.value)
  // return <span className={"isk"} title={numberWithCommas(props.value)}>
  //   <strong>{numberWithCommas(props.value/1000000)}</strong><span className={"text-muted"} style={{fontSize: 10}}>,000,000 ISK</span>
  // </span>
}


export default function BalancePage(props){
    const { t } = useTranslation(['pages', 'common']);
    let context = useContext(GlobalInfo);
    let [search, setSearch] = useState('');
    let [sortBy, setSortBy] = useState('weeklyIsk');

    let users = context.users;
    users.sort((a, b) => (b[sortBy]||(b['totalIsk']/1000000)) - (a[sortBy]||(a['totalIsk']/1000000)));
    console.log(users);

    return <div className={"container balance-page"}>

      <div className={"btn-tookbar mb-3"}>
        <div className={"input-group mr-2"}>
                  <div className="input-group-prepend">
          <span className="input-group-text" id="">{t('common:labels.search')}</span>
        </div>
          <input className="form-control" value={search} onChange={(e) => setSearch(e.target.value)} ref={input => input && input.focus()} />
        </div>
      </div>

      <table className={"table table-striped table-bordered"}>
        <thead>
          <tr>
            <th onClick={() => setSortBy('name')} style={{cursor: 'pointer'}}>
              {t('common:labels.pilot')} {sortBy === 'name' && '▼'}
            </th>
            <EngineerOnly>
              <th onClick={() => setSortBy('lastLogin')} style={{cursor: 'pointer'}}>
                {t('pages:balance.tableHeaders.lastLogin')} {sortBy === 'lastLogin' && '▼'}
              </th>
            </EngineerOnly>
            <EngineerOnly>
              <th>{t('pages:balance.tableHeaders.discordServers')}</th>
            </EngineerOnly>
            <th onClick={() => setSortBy('weeklyIsk')} style={{cursor: 'pointer'}}>
              {t('pages:balance.tableHeaders.weeklySupplied')} {sortBy === 'weeklyIsk' && '▼'}
            </th>
            <th onClick={() => setSortBy('totalIsk')} style={{cursor: 'pointer'}}>
              {t('pages:balance.tableHeaders.allTimeSupplied')} {sortBy === 'totalIsk' && '▼'}
            </th>
            <th onClick={() => setSortBy('balanceIsk')} style={{cursor: 'pointer'}}>
              {t('pages:balance.tableHeaders.iskBalance')} {sortBy === 'balanceIsk' && '▼'}
            </th>
            <th onClick={() => setSortBy('balancePanda')} style={{cursor: 'pointer'}}>
              {t('pages:balance.tableHeaders.pandaBalance')} {sortBy === 'balancePanda' && '▼'}
            </th>
            <th>{t('common:labels.actions')}</th>
            <th>{t('pages:balance.tableHeaders.links')}</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
                if(search.length > 0 && user.name.toLowerCase().indexOf(search.toLowerCase()) === -1) {
                  return null;
                }
            return <tr key={user.id}>
                <td>
                  {user.name}
                </td>
                <td>
                  <EngineerOnly>
                      {user.lastLogin ? new Date(user.lastLogin).toLocaleDateString() : t('pages:balance.never')}
                  </EngineerOnly>
                  &nbsp;
                </td>
                <td>
                  <EngineerOnly>
                    <Toggle title={`${t('pages:balance.servers')}${user.servers && user.servers.length > 0 ? ` (${user.servers.length})` : ''}`}>
                      {user.servers && user.servers.length > 0 ? (
                        <ul className="mb-0" style={{fontSize: '0.85em', paddingLeft: '1.2em'}}>
                          {user.servers.map((server, index) => (
                            <li key={index}>{server.name}</li>
                          ))}
                        </ul>
                      ) : (
                        <span className="text-muted">{t('pages:balance.none')}</span>
                      )}
                    </Toggle>
                  </EngineerOnly>
                </td>
                <td>{shortNumber((user.weeklyIsk + user.weeklyPanda) || 0)}</td>
                <td>{shortNumber(user.totalIsk + user.totalPanda)}</td>
                <td title={numberWithCommas(user.balanceIsk)}>{shortNumber(user.balanceIsk)} ISK</td>
                <td title={numberWithCommas(user.balanceIsk)}>{shortNumber(user.balancePanda)} {"\u{1F43C}"}</td>
                <td>
                  <EngineerOnly>
                    <TransactButton user={user} />
                  </EngineerOnly>
                  &nbsp;
                </td>
                <td>
                  <a href={"https://discord.com/users/" + user.id} className={"mr-2"}>Discord</a>
                  <a href={"/log/payout/?target_user_id=" + user.id}>{t('pages:balance.log')}</a>
                </td>
              </tr>

          })}
        </tbody>
      </table>
    </div>
}